var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteamLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.08,
    viewBox: "0 0 39.84 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "steam",
    className: "cls-1",
    d: "M2405.9,30A19.967,19.967,0,0,0,2386,48.671c0,0.005.01,0.01,0.01,0.015v0l10.72,4.424A5.5,5.5,0,0,1,2400,52.2l4.88-7.11a0.326,0.326,0,0,1-.01-0.1,7.58,7.58,0,1,1,7.58,7.612c-0.06,0-.11,0-0.17,0l-6.98,5a5.679,5.679,0,0,1-.43,2.285,5.523,5.523,0,0,1-10.5-.93l-7.55-3.124A19.957,19.957,0,1,0,2405.9,30Zm-7.51,30.631-2.46-1.025a4.244,4.244,0,0,0,7.77-.208h0a4.283,4.283,0,0,0,.01-3.279,4.246,4.246,0,0,0-5.45-2.373l2.55,1.059A3.154,3.154,0,0,1,2398.39,60.63Zm19.11-15.639a5.05,5.05,0,1,0-5.05,5.071A5.069,5.069,0,0,0,2417.5,44.991Zm-8.83-.008a3.79,3.79,0,1,1,3.79,3.808A3.8,3.8,0,0,1,2408.67,44.983Z",
    transform: "translate(-2386 -30)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteamLogo);
export default __webpack_public_path__ + "static/media/steamLogo.0b2edd2573e16d3e64179294d19ccd01.svg";
export { ForwardRef as ReactComponent };